import React, { useEffect, useRef, useContext } from "react";
import SubleaguesListTableContainer from "./Containers/SubleaguesListTableContainer";
import PropTypes from 'prop-types';
import { IsMobileContext } from "../isMobileContext";


const SubleagueListPanel = ({type, open}) => {
    const element = useRef(null);
    const ctx = useContext(IsMobileContext);

    useEffect(() => {
        if(element.current && open && ctx.isMobile){
            window.scrollTo({
                top: element.current.offsetTop,
                behavior: "smooth",
              });
        }
    }, [type, open]);

    if (!open) {
        return null;
    }

    return <section ref={element} id="subleague-list-panel" className="ranking-table module">
        <header className="module__header">
            <h2 className="ranking-table__title module__title">{getTitle(type)}</h2>
        </header>
        <SubleaguesListTableContainer/>
    </section>
};

SubleagueListPanel.propTypes = {
    type: PropTypes.string.isRequired,
    open: PropTypes.bool,
};

export default SubleagueListPanel;

const getTitle = function (type) {
    return type === 'open' ? 'Open Subleague' : 'Prize Subleague';
};


